<template>
  <!-- Chat block -->
  <div class="chatDiv" @click="noticeEvent('showChat')">
    <block-title @noticeEvent="noticeEvent" :message="message" />
    <p style="padding-top: 8px; text-align: left" class="noticeText">
      <span>
        <b v-if="user_id == message.sender_user_id">Me:</b>
        <p v-html="message.message"></p>
      </span>
      <span v-if="message.unread > 0" class="pull-right colorTrump">
        <b>{{ message.unread }}</b>
        <i class="fas fa-envelope"></i>
      </span>
    </p>
    <div>
      <span class="seeMoreLabel" style="margin-bottom: 10px">See more</span>
    </div>
    <div class="institution" v-if="message.school_logo">
      <img src="@/assets/triangle.png" class alt />
      <div class="logo">
        <img
          v-if="message.school_logo"
          :src="
            message.bucket_url +
            '/council/schools/photo/100/' +
            message.school_logo
          "
          alt
        />
      </div>
    </div>
    <div style="clear: both"></div>
  </div>
</template>
<style scoped></style>
<script>
import BlockTitle from "@/components/noticeTypes/other/BlockTitle";
export default {
  name: "chat",
  components: {
    BlockTitle,
  },
  props: {
    message: Object,
    user_id: Number,
  },
  methods: {
    noticeEvent(type) {
      this.$emit("noticeEvent", {
        action: type,
        id: this.message.user_id,
        user_id: this.message.user_id,
      });
    },
  },
};
</script>
